function formatData(data) {
  if (typeof data === 'object') {
    return JSON.stringify(data)
  }
  return data
}

function fetchData(params) {
  const method = params.method || 'POST'
  const data = Object.keys(params.data || {})
    .map(function (key) {
      const formattedData = formatData(params.data[key])
      return encodeURIComponent(key) + '=' + encodeURIComponent(formattedData)
    })
    .join('&')
  const options = {
    method,
    headers: {
      accept: 'application/json, text/javascript, */*; q=0.01',
      'accept-language': 'es-ES,es;q=0.9,en;q=0.8',
      'cache-control': 'no-cache',
      'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      pragma: 'no-cache',
      'x-requested-with': 'XMLHttpRequest',
    },
    body: data,
  }
  return fetch(params.url, options)
}

const apiManager = async params => {
  const response = await fetchData(params)

  if (!response.ok && response.status !== 200) {
    throw new Error(response.statusText)
  }
  return response
}

const apiManagerFetch = async params => {
  return await fetchData(params)
}

export default apiManager
export { apiManagerFetch }
